import React from 'react';
import './WaveVisualizer.css';

export function WaveVisualizer({ active = false, color = 'primary', barsCount = 12 }) {
  const bars = Array.from({ length: barsCount });

  return (
    <div className={`wave-visualizer ${active ? 'active' : ''} color-${color}`}>
      {bars.map((_, idx) => (
        <span
          key={idx}
          className="wave-bar"
          style={{
            animationDelay: `${(idx * 0.1) % 0.8}s`,
            height: active ? undefined : '4px',
          }}
        />
      ))}
    </div>
  );
}
